export class Status {
    Code: string;
    Name: string;
  }